module.exports = __webpack_public_path__ + "static/media/About_ProCompIllustration.c56bca82.png";